import { createMiddleware } from "@tanstack/react-start"

let isSentryInitialized = false

export const sentryMiddleware = createMiddleware().server(async ({ next }) => {
  const Sentry = await import("@sentry/node")

  if (!isSentryInitialized) {
    Sentry.init({
      dsn: process.env.VITE_SENTRY_DSN,
      tracesSampleRate: 1.0,
      environment: process.env.VITE_VERCEL_ENV ?? "development",
    })
    isSentryInitialized = true
  }

  try {
    return await next()
  } catch (error) {
    Sentry.captureException(error)
    throw error
  }
})
